import { motion } from "framer-motion";
import { useContext } from "react";
import { FaHeart, FaHome, FaShoppingCart, FaUser } from "react-icons/fa";
import { MdCategory } from "react-icons/md";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  NAV_CART,
  NAV_HOME,
  NAV_PROFILE,
  NAV_SHOP,
  NAV_SIGN_IN,
  NAV_WISHLIST,
  ROUTES,
} from "../constants";
import Context from "../context";

const NAV_ITEMS = [
  { label: NAV_HOME, path: ROUTES.HOME, icon: FaHome },
  { label: NAV_SHOP, path: ROUTES.PRODUCT_CATEGORY, icon: MdCategory },
  { label: NAV_WISHLIST, path: ROUTES.WISHLIST, icon: FaHeart },
  { label: NAV_CART, path: ROUTES.CART, icon: FaShoppingCart, showBadge: true },
];

const MobileNavbar = () => {
  const location = useLocation();
  const context = useContext(Context);
  const cartCount = context?.cartProductCount || 0;
  const user = useSelector((state) => state?.user?.user);

  const accountItem = {
    label: user?._id ? NAV_PROFILE : NAV_SIGN_IN,
    path: user?._id ? ROUTES.ACCOUNT : ROUTES.LOGIN,
    icon: FaUser,
    profilePic: user?.profilePic,
  };

  const allItems = [...NAV_ITEMS, accountItem];

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-xl border-t border-surface-border z-[100] pb-safe">
      <div className="flex items-stretch h-16">
        {allItems.map((item) => {
          const isActive =
            location.pathname === item.path ||
            (item.path !== ROUTES.HOME &&
              location.pathname.startsWith(item.path));
          const isCart = item.showBadge;
          const Icon = item.icon;

          return (
            <Link
              key={item.label}
              to={item.path}
              className="flex flex-col items-center justify-center gap-0.5 flex-1 relative tap-highlight-none"
            >
              {/* Active indicator */}
              {isActive && (
                <motion.span
                  layoutId="mobile-nav-indicator"
                  className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-[3px] bg-accent rounded-full"
                />
              )}

              {/* Icon */}
              <div className="relative">
                {item.profilePic ? (
                  <img
                    src={item.profilePic}
                    className={`w-6 h-6 rounded-full object-cover border-2 transition-all ${isActive ? "border-accent" : "border-surface-border"}`}
                    alt="User"
                  />
                ) : (
                  <Icon
                    className={`text-lg transition-all duration-200 ${
                      isActive ? "text-accent scale-110" : "text-neutral-400"
                    }`}
                  />
                )}

                {/* Cart badge */}
                {isCart && cartCount > 0 && (
                  <span className="absolute -top-1.5 -right-2 bg-accent text-white text-[8px] font-black min-w-[14px] h-3.5 rounded-full flex items-center justify-center px-1 border-[1.5px] border-white shadow-sm">
                    {cartCount > 99 ? "99+" : cartCount}
                  </span>
                )}
              </div>

              {/* Label */}
              <span
                className={`text-[9px] font-bold transition-colors duration-200 ${
                  isActive ? "text-accent" : "text-neutral-400"
                }`}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNavbar;
